import { Routes, Route } from "react-router-dom";

import HomePage from "./pages/HomePage/HomePage";
import ServicesPage from "./pages/ServicesPage/ServicesPage";
import ServicesInfo from "./pages/ServicesPage/components/ServicesInfo";
import LocationsPage from "./pages/LocationsPage/LocationsPage";
import LocationsInfo from "./pages/LocationsPage/components/LocationsInfo";
import ScrollToTop from "./ScrollToTop";
import WhatsAppButton from "./reusableUi/WhatsappButton";

function App() {
  return (
    <>
      <ScrollToTop />

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/services" element={<ServicesPage />} />
        <Route path="/services/:slug" element={<ServicesInfo />} />
        <Route path="/locations" element={<LocationsPage />} />
        <Route path="/locations/:slug" element={<LocationsInfo />} />
      </Routes>

      <WhatsAppButton />
    </>
  );
}

export default App;